
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/great-places-to-work/[...url_slugs]",
      function () {
        return require("private-next-pages/great-places-to-work/[...url_slugs]/index.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/great-places-to-work/[...url_slugs]"])
      });
    }
  